<template>
  <div>
    <!-- CAMPAIGN CHART SECTION -->
    <section-page :title="chartSectionTitle">
      <template v-slot:right>
        <stats-campaigns-filter @applyFilter="loadChartData"/>
      </template>

      <app-loading-section :loading="chartIsLoading">
        <stats-campaigns-chart
          :chart="campaignChartData"
          :lead-chart-data="leadChartData"
          :contracted-chart-data="contractedChartData"
          :closed-chart-data="closedChartData"
        />
      </app-loading-section>
    </section-page>

    <!-- CAMPAIGN TABLE BREAKDOWN -->
    <section-page title="Breakdown By Campaign">
      <app-loading-section :loading="tableIsLoading">
        <stats-campaigns-table :campaigns="campaignTableData"/>
      </app-loading-section>
    </section-page>
  </div>
</template>

<script>

import StatsCampaignsTable from "./components/StatsCampaignsTable.vue";
import StatsCampaignsChart from "./components/StatsCampaignsChart.vue";
import StatsCampaignsFilter from "./components/StatsCampaignsFilter.vue";
import utils from "../../services/utils";
import api from "../../api";

export default {
  name: "StatsCampaignsTab",
  components: {StatsCampaignsFilter, StatsCampaignsChart, StatsCampaignsTable},
  data() {
    return {
      chartIsLoading: false,
      tableIsLoading: false,
      campaignTableData: [],
      campaignChartData: {
        cost: 0,
        leads: 0,
        contracted: 0,
        closed: 0,
        projected_profit: 0,
        actual_profit: 0,
      },
      leadChartData: {
        labels: [],
        datasets: [{
          label: 'Leads',
          data: [],
          backgroundColor: [
            'rgb(255, 196, 0)',
            'rgb(30, 136, 229)',
            'rgb(242, 84, 48)',
            'rgb(76, 175, 80)',
            'rgb(198, 40, 40)',
          ],
          hoverOffset: 4,
          borderWidth: 4,
        }]
      },
      contractedChartData: {
        labels: [],
        datasets: [{
          label: 'Contracted',
          data: [],
          backgroundColor: [
            'rgb(30, 136, 229)',
            'rgb(76, 175, 80)',
            'rgb(198, 40, 40)',
          ],
          hoverOffset: 4,
          borderWidth: 4,
        }]
      },
      closedChartData: {
        labels: [],
        datasets: [{
          label: 'Closed',
          data: [],
          backgroundColor: [
            'rgb(30, 136, 229)',
            'rgb(76, 175, 80)',
            'rgb(198, 40, 40)',
          ],
          hoverOffset: 4,
          borderWidth: 4,
        }]
      },
    }
  },
  mounted() {
    this.loadTableData()
  },
  computed: {
    chartSectionTitle() {
      return `Total Campaign Costs ${utils.formatCurrency(this.campaignChartData.cost)}`
    },
  },
  methods: {
    loadChartData(filterData) {
      const data = {
        campaign_ids: filterData.campaignIds,
        start_at: filterData.timeframe.startAt,
        end_at: filterData.timeframe.endAt
      }

      this.chartIsLoading = true
      return Promise.all([
        api.stats.getStatsCampaignChart(data),
        api.stats.getStatsCampaignLeadChart(data),
        api.stats.getStatsCampaignContractedChart(data),
        api.stats.getStatsCampaignClosedChart(data),
      ]).then(([chart, leads, contracted, closed]) => {
        this.campaignChartData = chart.data.data

        this.leadChartData.labels = leads.data.data.labels
        this.leadChartData.datasets[0].data = leads.data.data.values

        this.contractedChartData.labels = contracted.data.data.labels
        this.contractedChartData.datasets[0].data = contracted.data.data.values

        this.closedChartData.labels = closed.data.data.labels
        this.closedChartData.datasets[0].data = closed.data.data.values
      })
      .finally(() => this.chartIsLoading = false);
    },
    loadTableData() {
      this.tableIsLoading = true
      api.stats.getStatsCampaignSummary()
        .then(res => {
          this.campaignTableData = res.data
        })
        .finally(() => this.tableIsLoading = false)
    },
  }
}
</script>

<style scoped lang="scss">

</style>
